import { render, staticRenderFns } from "./CartItemList.vue?vue&type=template&id=88bd5f30&scoped=true"
import script from "./CartItemList.vue?vue&type=script&lang=js"
export * from "./CartItemList.vue?vue&type=script&lang=js"
import style0 from "./CartItemList.vue?vue&type=style&index=0&id=88bd5f30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd5f30",
  null
  
)

export default component.exports